<template>
  <div class="lyformitem">
    <p
      v-show="!hideLabel"
      class="label"
      :style="{ color: color, fontWeight, fontSize, width: lw + 'em' }"
    >
      {{ label }}
    </p>
    <p :style="{ width: 'calc(100% - ' + (hideLabel ? 0 : lw) + 'em' }">
      <slot></slot>
    </p>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    lw: {
      type: Number,
      default: 5,
    },
    color: {
      type: String,
      default: "#666",
    },
    fontWeight: {
      type: Number | String,
      default: 400,
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    fontSize: {
      type: String,
    },
  },
};
</script>
<style scoped>
.lyformitem {
  margin-bottom: 8px;
  display: flex;
}
.lyformitem .label {
  margin-right: 4px;
}
</style>



// WEBPACK FOOTER //
// ../common/src/components/lyFormItem.vue